import Submit from '~/components/button/Submit';
import Form from '~/components/Form';
import RadioGroup from '~/components/form-controls/RadioGroup';
import Page from '~/components/layout/page/Page';
import { ReturnShipmentType } from '~/utils/constants';
import { HappyReturnsReturnMethod } from './HappyReturnMethod';
import { LabelOrPackingSlipMethod } from './LabelOrPackingSlipMethod';
import { useLoaderData } from './returnMethods';

export default function ReturnMethodsPage() {
  const { methods } = useLoaderData();

  return (
    <Page.Root title="How would you like to return your items?">
      <Form>
        <RadioGroup label="Return Methods" showLabel={false}>
          <div className="flex flex-col gap-4">
            {/* the loader sorts by priority, so the first card is the one to preselect */}
            {methods.map((method, index) =>
              method.type === ReturnShipmentType.consolidatedDropoff ? (
                <HappyReturnsReturnMethod
                  key={method.type}
                  method={method}
                  defaultChecked={index === 0}
                />
              ) : (
                <LabelOrPackingSlipMethod
                  key={method.type}
                  method={method}
                  defaultChecked={index === 0}
                />
              ),
            )}
          </div>
        </RadioGroup>
        <Submit>Next</Submit>
      </Form>
    </Page.Root>
  );
}
